import { useClientLimitedEvents } from '@ukpostbox/client-data';

function DataPreFetcher() {
	const { data: eventsData } = useClientLimitedEvents();

	return null;
}

export { DataPreFetcher };
